import React from 'react';
import { BookOpenIcon } from 'lucide-react';
import { brokerExample, helocExample, originationExample } from '../../data/loanCommission';
import { CommissionLine } from '../../types/commission';
import { formatPct, formatUsd } from '../../utils/format';
import { Card } from '../sf/Card';
import { ExampleDataBadge } from '../sf/ExampleDataBadge';
import { CommissionLinesTable } from './CommissionLinesTable';
interface ReferenceExamplesCardProps {
  lines: CommissionLine[];
  selectedId: string | null;
  onSelect: (id: string) => void;
  onRuleKeyClick: () => void;
}
export function ReferenceExamplesCard({
  lines,
  selectedId,
  onSelect,
  onRuleKeyClick
}: ReferenceExamplesCardProps) {
  const broker = brokerExample;
  const heloc = helocExample;
  const orig = originationExample;
  return <Card title="Reference examples from other loans" icon={BookOpenIcon} iconBg="#706E6B" meta="A 60 / 40 split, a Miami Director row (5 bps from the employee record), a self-gen skipped Team Lead row, an adjustment from a locked period, and Broker, HELOC and origination Adjusted Loan Amounts. Not part of any total." bodyClassName="" actions={<ExampleDataBadge data-id="element-553" data-mp="p0na1ekqa7mj" />} data-id="element-552" data-mp="oib5xftxfrjf">
      <CommissionLinesTable lines={lines} selectedId={selectedId} onSelect={onSelect} onRuleKeyClick={onRuleKeyClick} showLoanNumber data-id="element-554" data-mp="p1ow0e3a8ej1" />
      <div className="space-y-3 border-t border-sf-border px-4 py-3" data-id="element-555" data-mp="k3di9s9v9jvj">
        <div data-id="element-556" data-mp="1gqi8c0qkd7nc">
          <p className="text-[13px] font-semibold" data-id="element-557" data-mp="1gr9uym26nv1h">Broker non-HELOC loan · Adjusted Loan Amount</p>
          <p className="mt-0.5 text-[13px] tabular-nums" data-id="element-558" data-mp="1cqpvhbu50fc6">
            {formatUsd(broker.loanAmount)} × Total Comp Broker {formatPct(broker.compPct)} = {formatUsd(broker.revenue)} · no fee short ÷ {formatPct(broker.divisorPct)} (
            {broker.divisorRuleKey}) = <strong data-id="element-559" data-mp="3shvnzncc4nbz">{formatUsd(broker.adjustedAmount)}</strong>
          </p>
          <p className="text-xs text-sf-weak" data-id="element-560" data-mp="3ni99lakrt11l">Total Comp Broker % = Commissions ÷ Loan Amount × 100. Broker loans never have a fee short.</p>
        </div>
        <div data-id="element-561" data-mp="3p0q1rfzv1ho1">
          <p className="text-[13px] font-semibold" data-id="element-562" data-mp="3p07wjtv7zt3z">Non-correspondent HELOC / HELOAN · Adjusted Loan Amount</p>
          <p className="mt-0.5 text-[13px] tabular-nums" data-id="element-563" data-mp="3twf4fs76feok">
            {formatUsd(heloc.loanAmount)} × {formatPct(heloc.compPct)} = {formatUsd(heloc.revenue)} ÷ {formatPct(heloc.divisorPct)} ({heloc.divisorRuleKey}) ={' '}
            <strong data-id="element-564" data-mp="368xabq0fw4if">{formatUsd(heloc.adjustedAmount)}</strong>
          </p>
        </div>
        <div data-id="element-565" data-mp="3673zrzmph055">
          <p className="text-[13px] font-semibold" data-id="element-566" data-mp="3azdmz7wfrm3q">Origination path · Adjusted Loan Amount</p>
          <p className="mt-0.5 text-[13px] tabular-nums" data-id="element-567" data-mp="2x88x2xive86l">
            Origination Fee {formatUsd(orig.originationFee)} ÷ {formatPct(orig.divisorPct)} ({orig.divisorRuleKey}) = <strong data-id="element-568" data-mp="31a3v9t5i85g5">{formatUsd(orig.adjustedAmount)}</strong>
          </p>
          <p className="text-xs text-sf-weak" data-id="element-569" data-mp="2nb48kr1jy0mm">Used when Origination Fee &gt; 0.</p>
        </div>
      </div>
    </Card>;
}